'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageService = function () {
  function MessageService($http) {
    'ngInject';

    _classCallCheck(this, MessageService);

    this.$http = $http;
  }

  _createClass(MessageService, [{
    key: 'getAdminMessage',
    value: function getAdminMessage() {
      return this.$http.get('/api/message/load_nasc_message');
    }
  }, {
    key: 'getCompanyMessage',
    value: function getCompanyMessage() {
      return this.$http.get('/api/message/load_company_message');
    }
  }, {
    key: 'updateAdminMessage',
    value: function updateAdminMessage(message) {
      return this.$http.put('/api/message/nasc', {
        message: message
      });
    }
  }, {
    key: 'updateCompanyMessage',
    value: function updateCompanyMessage(message) {
      return this.$http.put('/api/message/company', {
        message: message
      });
    }
  }]);

  return MessageService;
}();

exports.default = MessageService;


// WEBPACK FOOTER //
// ./services/message.service.js